import React, { FC, memo } from "react";
import { Container } from "@montana/shared/container";
import { IStoreLocatorPage } from "@montana/models/generated/cms.interface";
import { StoreLocator } from "./store-locator/store-locator.component";
import { DynamicBlocks } from "@montana/blocks/dynamic-blocks.component";

export const StoreLocatorPage: FC<IStoreLocatorPage> = memo((props: IStoreLocatorPage) => {
    const { topBlocks, bottomBlocks } = props;

    return (
        <Container>
            <DynamicBlocks blocks={topBlocks} />
            <div className="store-locator__container app__block-spacing">
                <StoreLocator />
            </div>
            <DynamicBlocks blocks={bottomBlocks} />
        </Container >
    )
});
